document.addEventListener('turbo:load', () => {
  $('#invoice_payer_id').select2({allowClear: true});
  const calculateTotal = () => {
    // 必要な要素が存在しない場合は処理を終了（請求書ページ以外）
    if (!document.getElementById('total-amount')) {
      return;
    }
    
    let rawAmount = 0;
    let consumptionTaxAmount = 0;
    let withholdingAmount = 0;
    let expenseAmount = 0;
    let depositAmount = 0;
    
    // 時間報酬の集計
    document.querySelectorAll('.wage-checkbox:checked').forEach(checkbox => {
      const row = checkbox.closest('tr');
      const amount = parseFloat(row.querySelector('[data-amount]').dataset.amount) || 0;
      const tax = parseFloat(row.querySelector('[data-consumption-tax]').dataset.consumptionTax) || 0;
      const withholding = parseFloat(row.querySelector('[data-withholding]').dataset.withholding) || 0;
      
      rawAmount += amount + withholding - tax;
      consumptionTaxAmount += tax;
      withholdingAmount += withholding;
    });

    // 経費の集計（通常経費）
    document.querySelectorAll('.expense-checkbox:checked').forEach(checkbox => {
      const row = checkbox.closest('tr');
      const amount = parseFloat(row.querySelector('[data-amount]').dataset.amount) || 0;
      
      expenseAmount += amount;
    });

    // 預り金の集計
    document.querySelectorAll('.deposit-checkbox:checked').forEach(checkbox => {
      const row = checkbox.closest('tr');
      const amount = parseFloat(row.querySelector('[data-amount]').dataset.amount) || 0;
      
      depositAmount += amount;
    });

    // 売上の集計
    document.querySelectorAll('.earning-checkbox:checked').forEach(checkbox => {
      const row = checkbox.closest('tr');
      const amount = parseFloat(row.querySelector('[data-amount]').dataset.amount) || 0;
      const tax = parseFloat(row.querySelector('[data-consumption-tax]').dataset.consumptionTax) || 0;
      const withholding = parseFloat(row.querySelector('[data-withholding]').dataset.withholding) || 0;
      
      rawAmount += amount + withholding - tax;
      consumptionTaxAmount += tax;
      withholdingAmount += withholding;
    });

    // 請求金額 = 本体価格 + 実費 + 消費税 - 源泉徴収額
    const totalAmount = rawAmount + expenseAmount + consumptionTaxAmount - withholdingAmount + depositAmount;

    // 金額を表示（要素が存在する場合のみ）
    const rawAmountEl = document.getElementById('raw-amount');
    const expenseAmountEl = document.getElementById('expense-amount');
    const depositAmountEl = document.getElementById('deposit-amount');
    const consumptionTaxAmountEl = document.getElementById('consumption-tax-amount');
    const withholdingAmountEl = document.getElementById('withholding-amount');
    const totalAmountEl = document.getElementById('total-amount');
    
    if (rawAmountEl) rawAmountEl.textContent = formatCurrency(rawAmount);
    if (expenseAmountEl) expenseAmountEl.textContent = formatCurrency(expenseAmount);
    if (depositAmountEl) depositAmountEl.textContent = formatCurrency(depositAmount);
    if (consumptionTaxAmountEl) consumptionTaxAmountEl.textContent = formatCurrency(consumptionTaxAmount);
    if (withholdingAmountEl) withholdingAmountEl.textContent = formatCurrency(withholdingAmount);
    if (totalAmountEl) totalAmountEl.textContent = formatCurrency(totalAmount);

    // hidden fieldsに値を設定（要素が存在する場合のみ）
    const invoiceRawAmountEl = document.getElementById('invoice_raw_amount');
    const invoiceExpenseAmountEl = document.getElementById('invoice_expense_amount');
    const invoiceDepositAmountEl = document.getElementById('invoice_deposit_amount');
    const invoiceConsumptionTaxAmountEl = document.getElementById('invoice_consumption_tax_amount');
    const invoiceWithholdingAmountEl = document.getElementById('invoice_withholding_amount');
    const invoiceAmountEl = document.getElementById('invoice_amount');
    
    if (invoiceRawAmountEl) invoiceRawAmountEl.value = rawAmount;
    if (invoiceExpenseAmountEl) invoiceExpenseAmountEl.value = expenseAmount;
    if (invoiceDepositAmountEl) invoiceDepositAmountEl.value = depositAmount;
    if (invoiceConsumptionTaxAmountEl) invoiceConsumptionTaxAmountEl.value = consumptionTaxAmount;
    if (invoiceWithholdingAmountEl) invoiceWithholdingAmountEl.value = withholdingAmount;
    if (invoiceAmountEl) invoiceAmountEl.value = totalAmount;
  };

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('ja-JP', {
      style: 'currency',
      currency: 'JPY'
    }).format(amount);
  };

  // ページ読み込み時に初期計算を実行
  calculateTotal();

  // チェックボックスの変更時に再計算
  document.querySelectorAll('.item-checkbox').forEach(checkbox => {
    checkbox.addEventListener('change', calculateTotal);
  });

  document.querySelectorAll('.select-all').forEach(selectAll => {
    selectAll.addEventListener('change', calculateTotal);
  });

  // 全選択チェックボックスの処理
  document.querySelectorAll('.select-all').forEach(selectAll => {
    selectAll.addEventListener('change', (e) => {
      const table = e.target.closest('table');
      const checkboxes = table.querySelectorAll('.item-checkbox');
      checkboxes.forEach(checkbox => {
        checkbox.checked = e.target.checked;
      });
      calculateTotal();
    });
  });
});